import Currency from './Currency'

export default Currency
